import { gql } from '@apollo/client';

export const CREATE_PROSPECT_USER = gql`
  mutation CreateProspectUser($input: CreateProspectUserInput!) {
    createProspectUser(input: $input) {
      id
      utilityId
      zipcode
      firstName
      lastName
      phone
      email
    }
  }
`;
